import React from 'react';

export default function RotateMessage() {
  return (
    <div id="rotate-message">
        <div className="rotate-icon">⟳</div>
        <h3>Please Rotate to Landscape</h3>
    </div>
  );
}
